
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, VendorTemplateViewModel } from "@tylertech/tyler-api-types";

/**
 * VendorTemplateLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class VendorTemplateLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<VendorTemplateViewModel[]>> {
        return this.$apiService.sendAuth("IVendorTemplateLookupService/Lookup", pCriteria);
    }
}
